import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type PlayheadPositionChangedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type PlayheadPositionChangedSubscription = { __typename?: 'Subscription', playheadPositionChanged: { __typename?: 'PlayheadPositionPayload', positionMicroseconds: number, sequenceId: string } };


export const PlayheadPositionChanged = /*#__PURE__*/ gql`
    subscription PlayheadPositionChanged {
  playheadPositionChanged {
    positionMicroseconds
    sequenceId
  }
}
    ` as unknown as DocumentNode<PlayheadPositionChangedSubscription, PlayheadPositionChangedSubscriptionVariables>;

          

          export const usePlayheadPositionChangedSubscription = (options?:SubscriptionHookOptions<PlayheadPositionChangedSubscription, PlayheadPositionChangedSubscriptionVariables>) => useSubscription(PlayheadPositionChanged, options);

          

          export type PlayheadPositionChangedSubscriptionOptions = SubscriptionHookOptions<PlayheadPositionChangedSubscription, PlayheadPositionChangedSubscriptionVariables>;

          

          export type PlayheadPositionChangedSubscriptionResult = ReturnType<typeof usePlayheadPositionChangedSubscription>;

          
